var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tag,
    {
      tag: "component",
      staticClass: "button",
      class: ["button--" + _vm.level].concat(
        _vm.variants.map(function (variant) {
          return "button--" + variant
        }),
        [{ "button--icon": _vm.icon }],
        [{ "button--arrow": _vm.arrow }],
        [{ "button--no-text": !_vm.text }],
        [{ "button--reverse": _vm.reverse }],
        [{ "button--small": _vm.small }]
      ),
      attrs: {
        href: _vm.url || _vm.href,
        type: !_vm.url && _vm.type,
        target: _vm.url || _vm.href ? _vm.target : null,
        disabled: _vm.disabled,
      },
      on: { click: _vm.onClick },
    },
    [
      _vm.icon
        ? _c(_vm.iconComponent(_vm.icon), {
            tag: "component",
            staticClass: "button__icon",
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.text
        ? _c("span", {
            staticClass: "button__text",
            domProps: { innerHTML: _vm._s(_vm.text) },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }